import { Badge, Button, Modal, Segmented, Select, Tooltip } from "antd";

import React, { useEffect, useRef, useState } from "react";
import Icon from "../../assets/Icon";
import WebUtils from "../utils/WebUtils";
import { endInterviewApi } from "../../api";
import Utils from "../utils/Utils";
import MonitorStatusBadge from "../monitorTools/insideInterview/MonitorStatusBadge";

let osVer = Utils.getOSVersion();
let os = Utils.detectOS();

function TwoWayNavbar({
  timeRemaining,
  timeRemainingRef,
  chatMessagesRef,
  conversationHistory,
  endInterviewClickedFlag,
  socket,
  setLoading,
  deepgramStatus,
  previewConfig,
  interviewData,
  ip,
  stopRecording,
  videoBlobQueueRef,
  screenShareBlobQueueRef,
  interviewMode,
  setInterviewMode,
  allowUnloadRef,
  monitorStatus,
  fetchMonitorStatus,
}) {
  const [logCode, setLogCode] = useState("End interview success");
  const [logMessage, setLogMessage] = useState("Successfully passed");
  const [browser, setBrowser] = useState("");
  const [browserVer, setBrowserVer] = useState("");
  const endInterviewFlag = useRef(false);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [validateEndInterview, setValidateEndInterview] = useState(false);

  const handleTooltipCancel = () => {
    setTooltipVisible(false);
  };

  function browserCheck() {
    let userAgent = navigator.userAgent;

    // Detect Chrome & Edge
    if (/Edg/.test(userAgent)) {
      setBrowser("Microsoft Edge");
      setBrowserVer(userAgent.match(/Edg\/(\d+)/)[1]);
    } else if (/Chrome/.test(userAgent) && !/Chromium/.test(userAgent)) {
      setBrowser("Google Chrome");
      setBrowserVer(userAgent.match(/Chrome\/(\d+)/)[1]);
    }

    // Detect Firefox
    else if (/Firefox/.test(userAgent)) {
      setBrowser("Mozilla Firefox");
      setBrowserVer(userAgent.match(/Firefox\/(\d+)/)[1]);
    }
    // Detect Safari
    else if (/Safari/.test(userAgent)) {
      // browser = "Apple Safari";
      setBrowser("Apple Safari");
      setBrowserVer(userAgent.match(/Version\/(\d+)/)[1]);
    }
    // Detect Internet Explorer
    else if (/Trident/.test(userAgent)) {
      setBrowser("Internet Explorer");
      setBrowserVer(userAgent.match(/Trident\/\d+.*rv:(\d+)/)[1]);
    }
  }

  useEffect(() => {
    browserCheck();
  }, []);

  const endIntervalRef = useRef(null);

  const endInterviewFunc = () => {
    setLoading(true);
    console.log(
      "Video, Screen, Api :",
      videoBlobQueueRef.current.length,
      screenShareBlobQueueRef.current.length,
      endInterviewFlag.current,
    );
    if (
      videoBlobQueueRef.current.length === 0 &&
      screenShareBlobQueueRef.current.length === 0 &&
      endInterviewFlag.current
    ) {
      setLoading(false);
      clearInterval(endIntervalRef.current);
      allowUnloadRef.current = true;
      window.location.href = `/interview-completed?interviewId=${interviewData?.interviewId}`;
      return;
    }
  };

  // Function to format seconds into HH:MM:SS
  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = Math.round(timeInSeconds % 60);

    return [
      hours > 0 ? String(hours).padStart(2, "0") : null, // Show hours only if > 0
      String(minutes).padStart(2, "0"),
      String(seconds).padStart(2, "0"),
    ]
      .filter(Boolean) // Remove null if hours are not present
      .join(":");
  };

  const callEndInterviewApi = () => {
    let url = endInterviewApi;

    let browserData = navigator;
    const logBody = {
      role: interviewData?.userRole,
      name: interviewData?.name,
      osType: os,
      osVersion: osVer,
      browserType: browser,
      browserVersion: browserVer,
      ipAddress: ip,
      systemSpecs: {
        cookieEnabled: browserData.cookieEnabled,
        downLink: browserData.connection?.downLink,
        rtt: browserData.connection?.rtt,
        effectiveType: browserData.connection?.effectiveType,
        language: browserData.language,
        hardwareConcurrency: browserData.hardwareConcurrency,
        deviceMemory: browserData.deviceMemory,
        pdfViewerEnabled: browserData.pdfViewerEnabled,
      },
      dateTimeInfo: new Date().toISOString().slice(0, -5),
      logCode: logCode,
      logMessage: logMessage,
    };

    const requestBody = {
      interviewId: interviewData?.interviewId,
      ipLog: logBody,
      interviewType: interviewData?.interviewType,
      timeLeft: timeRemainingRef.current,
      interviewConversation: chatMessagesRef.current,
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
        endInterviewFlag.current = true;
      })
      .catch((err) => {
        endInterviewFlag.current = true;
        console.log(err);
      });
  };

  const endInterviewHandler = () => {
    endInterviewClickedFlag.current = true;
    socket?.emit("EndInterview");
    stopRecording();
    callEndInterviewApi();
    endIntervalRef.current = setInterval(endInterviewFunc, 500);
  };

  const initializeInterview = () => {
    window.location.href = `/preview?interviewId=${interviewData?.interviewId}`;

    // const botConfig = {
    //   ...conversationHistory,
    //   interviewHistory: chatMessagesRef.current,
    // };

    // socket.disconnect();
    // socket.connect();
    // setTimeout(() => {
    //   socket.emit("initializeInterview", botConfig);
    //   console.log("Initialized restarted.");
    // }, 5000);
  };

  return (
    <>
      <Modal
        className="rejoin-modal"
        open={validateEndInterview}
        onCancel={() => setValidateEndInterview(false)}
        footer={null}
        width={460}
        centered
      >
        <div className="">
          <Icon type="warning-icon" width="45" height="45" />
        </div>
        <div className="mt-[.55rem] font-semibold text-[1.05rem] text-[#101828]">
          End Interview
        </div>
        <div className="mt-[.35rem] text-[0.88rem] text-[#475467] leading-[1.38rem]">
          Are you sure you want to end the interview? Once ended, the interview
          will be marked as complete, and you won’t be able to join back.
        </div>
        <div className="flex gap-2 justify-end">
          <Button
            color="danger"
            variant="solid"
            className=" text-[.86rem] mt-[.35rem] px-[1.2rem]"
            onClick={endInterviewHandler}
          >
            Conclude Interview
          </Button>
        </div>
      </Modal>
      <div className="flex justify-between w-full pt-[.48rem] flex-wrap gap-x-[.65rem] gap-y-4 md:flex-nowrap mb-4">
        <div className="w-full lg:w-[53%]">
          <p className="font-semibold text-white text-[1.5rem] 2xl:text-3xl">
            <span className="text-[#FEC84B]">{interviewData?.jobTitle}</span> @
            {interviewData?.companyName}
          </p>
          <p className="text-[.7rem] 2xl:text-[.8rem] mt-[.3rem]">
            {interviewData?.interviewId}
          </p>
          <p className="text-[.95rem] 2xl:text-[1.1rem] text-[#FEC84B] mt-[.3rem]">
            Candidate Name: {interviewData?.candidateName}
          </p>
          <div className="flex flex-wrap gap-x-3 gap-y-2 text-[.72rem] 2xl:text-[.8rem] pt-1 text-[#12B76A] badge-component">
            <Badge
              color={
                deepgramStatus?.TrancriptionSocketStatus ? "#12B76A" : "#D92D20"
              }
              text={
                <span
                  style={{
                    fontWeight: 500,
                    color: deepgramStatus?.TrancriptionSocketStatus
                      ? "#12B76A"
                      : "#D92D20",
                  }}
                >
                  Transcribing
                </span>
              }
            />
            <Badge
              color={
                deepgramStatus?.SpeechSynthesisSocketStatus
                  ? "#12B76A"
                  : "#D92D20"
              }
              text={
                <span
                  style={{
                    fontWeight: 500,
                    color: deepgramStatus?.SpeechSynthesisSocketStatus
                      ? "#12B76A"
                      : "#D92D20",
                  }}
                >
                  Speech Synthesis
                </span>
              }
            />
            <Badge
              color={
                previewConfig?.videoRecordingRequired ? "#12B76A" : "#D92D20"
              }
              text={
                <span
                  style={{
                    fontWeight: 500,
                    color: previewConfig?.videoRecordingRequired
                      ? "#12B76A"
                      : "#D92D20",
                  }}
                >
                  Video Recording
                </span>
              }
            />
            <Badge
              color={
                previewConfig?.screenRecordingRequired ? "#12B76A" : "#D92D20"
              }
              text={
                <span
                  style={{
                    fontWeight: 500,
                    color: previewConfig?.screenRecordingRequired
                      ? "#12B76A"
                      : "#D92D20",
                  }}
                >
                  Screen Recording
                </span>
              }
            />
          </div>
        </div>
        <div className="lg:flex-1 flex flex-col gap-[.85rem] items-end">
          <div className="flex justify-start sm:justify-end items-center flex-wrap gap-x-[.75rem] gap-y-[.65rem]">
            <Tooltip
              color={"#0C111D"}
              overlayInnerStyle={{
                color: "#D0D5DD",
                padding: "12px 15px",
                width: "300px",
              }}
              placement="bottom"
              open={isTooltipVisible}
              onOpenChange={(visible) => setTooltipVisible(visible)}
              title={
                <div className="text-[0.86rem]">
                  <div className="text-white font-semibold">Help</div>
                  <div className="mt-[.35rem] font-medium">
                    If the bot isn't responding at all, click on Rejoin to
                    rejoin the interview.
                  </div>
                  <div className="flex justify-end gap-2 mt-2">
                    <Button
                      className="py-[0.75rem] px-2 text-[0.86rem]"
                      size="small"
                      // onClick={() => socket.emit("EndInterview")}
                      onClick={() => handleTooltipCancel()}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={initializeInterview}
                      className="py-[0.75rem] px-2 text-[0.86rem]"
                      size="small"
                      type="primary"
                    >
                      Rejoin
                    </Button>
                  </div>
                </div>
              }
            >
              <div className="flex gap-[.45rem] justify-center items-center hover:cursor-pointer">
                <span className="text-[.85rem] 2xl:text-[1rem]">Help</span>
                <Icon type="help-icon" strokeWidth="1.8" />
              </div>
            </Tooltip>

            <div id="tour-mode-switch" className="main-interview-segmented">
              <Segmented
                options={[
                  {
                    label: (
                      <div className="text-[.8rem] 2xl:text-[.92rem]">
                        Hands-free Mode
                      </div>
                    ),
                    value: "Hands-free",
                  },
                  {
                    label: (
                      <div className="text-[.8rem] 2xl:text-[.92rem]">
                        Manual Mode
                      </div>
                    ),
                    value: "Manual",
                  },
                ]}
                value={interviewMode}
                onChange={(value) => {
                  setInterviewMode(value);
                }}
              />
            </div>

            <div className="bg-white text-[#081B31] flex items-center gap-[0.5rem] justify-center rounded-md px-[.7rem] py-[.4rem] font-semibold text-[0.94rem]">
              <Icon type="clock" color="black" width="18" height="18" />{" "}
              <div className="font-[monospace] text-[.9rem] 2xl:text-[1.08rem] ">
                {formatTime(timeRemaining)}
              </div>
            </div>
            <Button
              color="danger"
              variant="solid"
              className="w-[125px] font-semibold text-[.83rem] 2xl:text-[.92rem]"
              size="large"
              onClick={() => {
                setValidateEndInterview(true);
              }}
            >
              End Interview
            </Button>
          </div>
          {previewConfig?.monitoringToolEnabled && (
            <MonitorStatusBadge
              fetchMonitorStatus={fetchMonitorStatus}
              monitorStatus={monitorStatus}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default TwoWayNavbar;
